export default __webpack_public_path__ + "static/media/build-icon.a1d1c54c.svg";